import { Col, Collapse, Row, Tabs } from 'antd';
import React from 'react';
import { uuid } from "rt-sd-common/sgiCommon/sgiCommon";
import { sgiLogger } from 'rt-sd-common/sgiCommon/sgiLogger';
import { ObjFactory } from 'rt-sd-common/sgiFactory/ObjFactory';
import { PrmFactory } from 'rt-sd-common/sgiFactory/PrmFactory';
import { Resource } from 'rt-sd-common/sgiFactory/Resource';
import { SgiMainComp } from 'rt-sd-comp/sgiComp/SgiMainComp';
const TabPane = Tabs.TabPane;
const Panel = Collapse.Panel;

/**
 * 额外要做代理解析的keys
 */
const otherProxyKeys = ["eventKeys"];
/**
 * 参数Editor编辑器使用，将moduleDesc用代理器包裹一下，传至页面对象工厂中的values身上。
 * 功能：当values（moduleDesc）中的属性变动时，刷新组件并修改要保存的json
 */
const getModuleDesc2valuesHandler = (dndDispatchObject, dnd_id) => ({
	set: function (target, key, value, receiver) {
		if (key === "_currentDndCtl") {
			return Reflect.set(this, key, value);
		} else if (key === "_prefix") {
			return Reflect.set(this, key, value);
			// } else if (key === "cldSet" && this._currentDndCtl) {
			//     return new Proxy(target[key], {})
			//     let sonItems = syncSonItems(target, key, value, this._currentDndCtl);
			//     console.log('proxyModuleDesc sonItems :', sonItems);
			//     this._currentDndCtl.setState({ sonItems });
		} else if (this._currentDndCtl) {
			this._currentDndCtl.refresh(key, value);
		}
		if (Object.prototype.toString.call(value) === "[object Object]") {
			let proxyVal = new Proxy(value, getModuleDesc2valuesHandler(dndDispatchObject, dnd_id));
			proxyVal._prefix = (this._prefix || "") + key + ".";
			proxyVal._currentDndCtl = this._currentDndCtl;
			return Reflect.set(target, key, proxyVal);
		} else {
			dndDispatchObject.updateUIJson(dnd_id, (this._prefix || "") + key, value);
			return Reflect.set(target, key, value);
		}
	}
});

function onDBClick(event) {
	// console.log(arguments);
	// console.log("thisModule", this);

	let dndDispatchObject = this.props.dndDispatchObject || this.state.dndDispatchObject;

	let mainUI = dndDispatchObject.getMainUI();
	fitModalInfo(this);
	mainUI.openModal();
	event.cancelBubble = true; //ie浏览器 组织向下传递
	event.stopPropagation(); //chrome等浏览器
}


/**
 * 组装弹出框 编辑信息
 */
function fitModalInfo(module) {

	let dndDispatchObject = module.props.dndDispatchObject || module.state.dndDispatchObject;

	let mainUI = dndDispatchObject.getMainUI();
	mainUI.state.modal_title = module.props.modal_title;
	if (sgiConfig.prmEditor || module.props.dndCompEditor === "_prmEditor") {
		let guid = (sgiConfig.prefix_editor || "rtsd_UI_Editor_") + module.props.modal_context.replace(/Editor$/, "");
		let prm = PrmFactory.getPrm(guid);
		if (prm && prm.guid) {
			// let objFct = new ObjFactory("sgiMainEditor", { values: module.props.moduleDesc });
			let moduleDesc = new Proxy(module.props.moduleDesc, getModuleDesc2valuesHandler(dndDispatchObject, module.props.moduleDesc.dnd_id));
			moduleDesc._currentDndCtl = module;
			otherProxyKeys.forEach(key => {
				if (moduleDesc[key]) {
					moduleDesc[key] = moduleDesc[key];
					// let proxyVal = new Proxy(moduleDesc[key], getModuleDesc2valuesHandler(dndDispatchObject,module.props.moduleDesc.dnd_id));
					// proxyVal._prefix = key + ".";
					// proxyVal._currentDndCtl = module;
					// moduleDesc[key] = proxyVal;
				}
			});
			let objFct = new ObjFactory("sgiMainEditor", { values: moduleDesc });
			mainUI.state.modal_context = <SgiMainComp key={uuid(8)} objFct={objFct} moduleDesc={prm} values={module.props.moduleDesc} currentCtl={module} />
			mainUI.state.editorType = "SDEditor";
			return;
		}
	}
	if (module.props.dndCompEditor) {
		mainUI.state.modal_context = <module.props.dndCompEditor values={module.props.moduleDesc} currentCtl={module} />;
		mainUI.state.editorType = "";
	} else {
		mainUI.state.modal_context = <div style={{ height: '300px' }}><h1>找不到编辑页面或不可编辑</h1></div>;
		mainUI.state.editorType = "";
	}
}

function onClick(moudule, event) {

	if (event) {
		event.cancelBubble = true; //ie浏览器 组织向下传递
		event.stopPropagation(); //chrome等浏览器
	}

	let parentModule = moudule.props.parentModule;
	let dndDispatchObject = moudule.props.dndDispatchObject || moudule.state.dndDispatchObject;

	//如果选中组件是当前组件，不做操作

	// console.log('同一个面板：' + diffMoudule(dndDispatchObject.getCurrentSelMoudle(), moudule))
	// console.log(dndDispatchObject.getCurrentSelMoudle())
	// console.log(moudule)
	if (diffMoudule(dndDispatchObject.getCurrentSelMoudle(), moudule)) {
		return;
	}

	let lastSelMoudule = dndDispatchObject.getCurrentSelMoudle();
	if (lastSelMoudule) {
		let lastProps = lastSelMoudule.state.formItemProps || lastSelMoudule.inputprops || lastSelMoudule.state;
		lastProps.style.border = '1px dashed grey'
		lastSelMoudule.setState({ hover: false });
	}

	sgiLogger.debug("moudule:", moudule);
	sgiLogger.debug("record:", moudule.props.moduleDesc);

	dndDispatchObject.setCurrentSelMoudle(moudule); //设置当前选中节点
	dndDispatchObject.setCurrentSelPraentMoudle(parentModule); //设置当前选中父节点

	fitModalInfo(moudule);
	let mainUI = dndDispatchObject.getMainUI(); //切到组件编辑面板

	mainUI.state.CurrentSelMoudlete = moudule.props.moduleDesc.te || moudule.props.moduleDesc.n;
	mainUI.state.CurrentSelMoudleguid = moudule.props.modal_title;
	// mainUI.setState({ activeKey: 'x' });
	mainUI.setState({ loading: true });
	mainUI.setState({
		selectedKeys: [moudule.props.moduleDesc.dnd_id],
		expandedKeys: [moudule.props.moduleDesc.dnd_id]
	});

	// 不存在事件的时候 是通过树点击调用过来的
	// 存在是点击页面调用的，点击页面调用 的时候  刷新树 节点
}

function diffMoudule(oldMoudule, newMoudule) {
	if (!oldMoudule || !newMoudule) {
		return false;
	}
	if (!oldMoudule || !oldMoudule.props || !oldMoudule.props.moduleDesc || !oldMoudule.props.moduleDesc.dnd_id) {
		return false;
	}
	if (!newMoudule || !newMoudule.props || !newMoudule.props.moduleDesc || !newMoudule.props.moduleDesc.dnd_id) {
		return false;
	}
	if (oldMoudule.props.moduleDesc.dnd_id == newMoudule.props.moduleDesc.dnd_id) {
		return true;
	}
	return false;
}


function toggleHover(moudule, event) { //给树点击用
	//this.state.style给拖拽控件使用的 formItemProps给sgiform控件使用的
	let props = moudule.state.formItemProps || moudule.inputprops || moudule.state;
	// if (!moudule.state.hover) {
	props.style.border = '1px dashed blue'
	// } else {
	//     props.style.border = '1px dashed grey'
	// }
	moudule.setState({ hover: !moudule.state.hover });
}

function toggleHoverEnter(moudule, event) {

	if (event) {
		event.cancelBubble = true; //ie浏览器 组织向下传递
		event.stopPropagation(); //chrome等浏览器
	}

	let dndDispatchObject = moudule.props.dndDispatchObject || moudule.state.dndDispatchObject;

	//如果选中组件是当前组件，不做操作
	// if (dndDispatchObject.getCurrentSelMoudle() == moudule) {
	// 	return;
	// }
	if (diffMoudule(dndDispatchObject.getCurrentSelMoudle(), moudule)) {
		return;
	}
	if (!moudule.state.hover) {
		let props = moudule.state.formItemProps || moudule.inputprops || moudule.state;
		props.style.border = '1px dashed red'
		moudule.setState({ hover: true });
	}

	// console.log("鼠标进入");
	// console.log(moudule.state.hover);
	// console.log(moudule);
}


function toggleHoverLeave(moudule, event) {

	if (event) {
		event.cancelBubble = true; //ie浏览器 组织向下传递
		event.stopPropagation(); //chrome等浏览器
	}

	let dndDispatchObject = moudule.props.dndDispatchObject || moudule.state.dndDispatchObject;
	//如果选中组件是当前组件，离开不再改变颜色，让当前选中组件一直高亮显示
	// if (dndDispatchObject.getCurrentSelMoudle() == moudule) {
	// 	return;
	// }
	if (diffMoudule(dndDispatchObject.getCurrentSelMoudle(), moudule)) {
		return;
	}

	// console.log("鼠标离开")
	// console.log(moudule.state.hover);
	// console.log(moudule);

	if (moudule.state.hover) {
		//this.state.style给拖拽控件使用的 formItemProps给sgiform控件使用的
		let props = moudule.state.formItemProps || moudule.inputprops || moudule.state;
		props.style.border = '1px dashed grey'
		moudule.setState({ hover: false });
	}
}



function toggleHoverEnterMain(moudule, event) {         //qiuyl
	// console.log("鼠标进入")
	//this.state.style给拖拽控件使用的 formItemProps给sgiform控件使用的
	// console.log(moudule);
	moudule.setState({ hover: true });
	if (event) {
		event.cancelBubble = true; //ie浏览器 组织向下传递
		event.stopPropagation(); //chrome等浏览器
	}
}



function toggleHoverLeaveMain(moudule, event) {         //qiuyl
	// console.log("鼠标离开")
	let dndDispatchObject = moudule.props.dndDispatchObject || moudule.state.dndDispatchObject;
	//如果选中组件是当前组件，离开不再改变颜色，让当前选中组件一直高亮显示
	if (dndDispatchObject.getCurrentSelMoudle() == moudule) {
		return;
	}
	//this.state.style给拖拽控件使用的 formItemProps给sgiform控件使用的
	// setTimeout(function () { moudule.setState({ hover: false }) }, 1000)
	moudule.setState({ hover: false });
	if (event) {
		event.cancelBubble = true; //ie浏览器 组织向下传递
		event.stopPropagation(); //chrome等浏览器
	}
}


function addMouseFun(moudule, params) {
	// params.onMouseEnter = toggleHoverEnter.bind(moudule, moudule);
	// params.onMouseLeave = toggleHoverLeave.bind(moudule, moudule);
	params.onMouseOver = toggleHoverEnter.bind(moudule, moudule);
	params.onMouseOut = toggleHoverLeave.bind(moudule, moudule);
	// params.onMouseLeave = toggleHover.bind(moudule, moudule);
}



function addMouseMainFun(moudule, params) {         //qiuyl
	// params.onMouseEnter = toggleHoverEnter.bind(moudule, moudule);
	// params.onMouseLeave = toggleHoverLeave.bind(moudule, moudule);
	params.onMouseOver = toggleHoverEnterMain.bind(moudule, moudule);
	params.onMouseOut = toggleHoverLeaveMain.bind(moudule, moudule);
	// params.onMouseLeave = toggleHover.bind(moudule, moudule);
}

/**
 * 对外接口,添加拖拽布局
 * @param {控件样式} style 
 */
// function addFormCtlDndInfo(moudule, formItemProps, inputprops, type) {
//     if (type != "dnd") {
//         return;
//     }
//     //状态中追加一个hover状态,默认为false
//     moudule.state.hover = false;
//     addMouseFun(moudule, inputprops);
//     inputprops.onDoubleClick = onDBClick.bind(moudule);
//     inputprops.onClick = onClick.bind(moudule);
//     formItemProps.style.border = '1px dashed grey';
// }


/**
 * 对外接口,tab添加拖拽布局，解决鼠标滑过变色问题和点击事件编辑
 * @param {控件样式} style 
 */
function addTabCtlDndInfoForDnd(moudule, tabsProps, type) {
	if (type != "dnd") {
		return;
	}
	//状态中追加一个hover状态,默认为false
	moudule.state.hover = false;
	addMouseFun(moudule, tabsProps);
	tabsProps.onDoubleClick = onDBClick.bind(moudule);
	tabsProps.onClick = onClick.bind(moudule, moudule);
}


function addTabCtlDndInfoForMainDnd(moudule, tabsProps, type) {
	if (type != "prev") {
		return;
	}
	//状态中追加一个hover状态,默认为false
	moudule.state.hover = false;
	addMouseMainFun(moudule, tabsProps);
	// tabsProps.onDoubleClick = onDBClick.bind(moudule);
	// tabsProps.onClick = onClick.bind(moudule, moudule);
}


/**
 * 对外接口,tab添加拖拽布局
 * @param {控件样式} style 
 */
function addTabCtlDndInfo(moudule, tabsItems, tabsProps, type) {
	if (type != "dnd") {
		return;
	}

	//获取拖拽数据
	let dndDispatchObject = moudule.props.dndDispatchObject || moudule.state.dndDispatchObject;

	let cldSet = moudule.props.children;
	if (cldSet && cldSet.length && cldSet.length > 0) {
		let tabPane;
		cldSet.forEach((item, index) => {
			let { cId, te, isDis } = item.props.moduleDesc;
			tabPane = {};
			if (!cId) {
				cId = uuid(8);
				item.props.moduleDesc.cId = cId; //赋值的同时，也要给json数据赋值，保持同步
				dndDispatchObject.updateUIJson(item.props.moduleDesc.dnd_id, "cId", cId);
			}
			if (te) tabPane.tab = Resource.getTRByPrm(item.props.moduleDesc).te;
			if (cId) tabPane.key = item.props.moduleDesc.dnd_id;
			if (isDis) tabPane.disabled = isDis;
			item.props.parentModule = moudule;
			tabsItems.push(<TabPane {...tabPane}>{item}</TabPane>);
		});
	}
}

/**
 * 对外接口,Collapse添加拖拽布局
 * @param {控件样式} style 
 */
function addCollapseCtlDndInfo(moudule, tabsItems, tabsProps, type) {
	if (type != "dnd") {
		return;
	}


	//获取拖拽数据
	let dndDispatchObject = moudule.props.dndDispatchObject || moudule.state.dndDispatchObject;

	let cldSet = moudule.props.children;
	if (cldSet && cldSet.length && cldSet.length > 0) {
		let cosPane;
		cldSet.forEach((item, index) => {
			let { cId, te, isDis } = item.props.moduleDesc;
			cosPane = {};
			if (!cId) {
				cId = uuid(8);
				item.props.moduleDesc.cId = cId; //赋值的同时，也要给json数据赋值，保持同步
				dndDispatchObject.updateUIJson(item.props.moduleDesc.dnd_id, "cId", cId);
			}
			if (te) cosPane.header = Resource.getTRByPrm(item.props.moduleDesc).te;
			if (cId) cosPane.key = item.props.moduleDesc.dnd_id;
			if (isDis) cosPane.disabled = isDis;
			item.props.parentModule = moudule;
			tabsItems.push(<Panel {...cosPane}>{item}</Panel>);
		});
	}
}
/**
 * 对外接口,toolbar添加拖拽布局
 * @param {控件样式} style 
 */
function addToolbarCtlDndInfo(moudule, tabsItems, tabsProps, type) {
	if (type != "dnd") {
		return;
	}

	let cldSet = moudule.props.children;
	var tlbAlg = moudule.props.moduleDesc.tlbAlg;//工具条位置  
	if (cldSet && cldSet.length && cldSet.length > 0) {
		if (!tlbAlg || tlbAlg == "top" || tlbAlg == "bottom") {
			cldSet.forEach((item, index) => {
				tabsItems.push(item);
			});
		} else if (tlbAlg == "left" || tlbAlg == "right") {
			var rowlist = [];
			cldSet.forEach((item, index) => {
				rowlist.push(<Row>{item}</Row>);
			});
			tabsItems.push(
				<Col>{rowlist}</Col>
			);
		}
	}
}

/**
 * 对外接口,Collapse添加拖拽布局
 * @param {控件样式} style 
 */
function addSgiSplitterCtlDndInfo(moudule, tabsItems, tabsProps, type) {
	if (type != "dnd") {
		return;
	}

	let { bdInst, objFct, moduleDesc } = moudule.props;
	let colList;
	//分割比例
	var p = moduleDesc.sptSca;
	var ps = p.split(",");

	//计数
	var sumPs = 0;
	for (var i = 0; i < ps.length; i++) {
		sumPs += parseInt(ps[i]);
	}
	var isEdwSpt = moduleDesc.isEdwSpt;//纵向分割

	colList = [];
	var children = moudule.props.children;
	if (children) {
		var childSize = children.length;
		if (childSize != 0) {
			for (var i = 0; i < childSize; i++) {
				if (!ps[i]) {
					ps[i] = 0;
				}
				var span = Math.round((parseInt(ps[i]) / sumPs) * 24);
				var height1 = (parseInt(ps[i]) / sumPs) * 100 + "%";

				if (isEdwSpt) {
					colList.push(<Row style={{ height: height1 }} >
						{children[i]}</Row>)
				} else {
					colList.push(<Col span={span} >
						{children[i]}</Col>)
				}
			}
			if (isEdwSpt) {
				tabsItems.push(colList);
			} else {
				tabsItems.push(<Row>{colList}</Row>);
			}
		}
	}
}

export { addTabCtlDndInfo, addTabCtlDndInfoForDnd, addCollapseCtlDndInfo, addSgiSplitterCtlDndInfo, addToolbarCtlDndInfo, toggleHover, onClick, toggleHoverLeave, addTabCtlDndInfoForMainDnd, fitModalInfo };
export default { addTabCtlDndInfo, addTabCtlDndInfoForDnd, addCollapseCtlDndInfo, addSgiSplitterCtlDndInfo, addToolbarCtlDndInfo, toggleHover, onClick, toggleHoverLeave, addTabCtlDndInfoForMainDnd, fitModalInfo };



// WEBPACK FOOTER //
// ./~/rt-sd-dnd/sgiDndDev/sgiDndDevComFun.js